import errorCodes from 'srcAlias/enums/errorCodes';

export const minTimeout = (timeout = 5000) => {
  return new Promise((resolve) => {
    return setTimeout(() => resolve(), timeout);
  });
};

export const maxTimeout = (timeout = 5000) => {
  return new Promise((resolve, reject) => {
    return setTimeout(() => {
      return reject({
        name: 'RequestTimeout',
        message: errorCodes.CLIENT_TIMEOUT,
      });
    }, timeout);
  });
};

export const minMaxTimeout = (promise, { min, max }) => {
  return Promise.race([
    Promise.all([promise, minTimeout(min)]),
    maxTimeout(max),
  ]);
};
